import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

const termsList = [
  'The content of this website is for your general information and use only. It may change without notice.',
  'This website uses cookies to monitor browsing preferences.',
  'Neither we nor any third parties provide any warranty or guarantee regarding the accuracy, timeliness, performance, completeness or suitability of the information and materials found on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.',
  'Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It is your responsibility to ensure that any products, services or information available through this website meet your specific requirements.',
  'This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice that forms part of these terms and conditions.',
  'All trademarks reproduced in this website that are not the property of, or licensed to, the operator are acknowledged on the website.',
  'Unauthorised use of this website may give rise to a claim for damages and/or be a criminal offence.',
  'From time to time this website may also include links to other websites. These links are provided for your convenience to provide further information. They do not signify that we endorse the website(s) and we have no responsibility for the content of the linked website(s).',
  'Your use of this website and any dispute arising out of such use of the website is subject to the jurisdiction of English law.'
];

const TermsOfUse = () => (
  <div className="TermsOfUse bg-white">
    <Header />
    <div className="mt-32 sm:mt-36 lg:mt-32">
      <Hero
        image="https://images.pexels.com/photos/5668882/pexels-photo-5668882.jpeg?auto=compress&cs=tinysrgb&w=1920"
        heightClass="min-h-[50vh] sm:min-h-[60vh] lg:min-h-[70vh]"
        position="center"
      />

      <div className="orange-line" />

    <section className="py-16 px-6 lg:px-12 bg-white">
      <div className="max-w-5xl mx-auto text-[#2b3d57] space-y-10">
        <header className="space-y-4">
          <p className="text-sm tracking-[0.35em] uppercase text-[#2f4c74]">Policies</p>
          <h1 className="text-4xl md:text-6xl font-light text-[#2b3d57]">Terms of Use</h1>
          <p className="text-xl leading-relaxed">
            Welcome to our website. If you continue to browse and use this site, you agree to comply with and
            be bound by these terms of use, which together with our Privacy Policy govern Testa Care&apos;s
            relationship with you. If you disagree with any part of these terms, please do not use our website.
          </p>
        </header>

        <div className="bg-[#f2f4f7] border border-[#f4e7da] p-6 rounded-xl space-y-3">
          <p className="font-semibold text-[#0d0d0d]">Testa Care</p>
          <p>Sigma Universal Ltd</p>
          <p>Davyfield Road</p>
          <p>Blackburn</p>
          <p>Lancashire</p>
          <p>England</p>
          <p>BB1 2QY</p>
          <p className="pt-2">
            Email:{' '}
            <a href="mailto:Info@testacare.co.uk" className="text-[#2f4c74] underline font-medium">
              Info@testacare.co.uk
            </a>
          </p>
        </div>

        <section className="space-y-4">
          <h2 className="text-3xl font-light text-[#2b3d57]">Using this website</h2>
          <p>
            The term &quot;Testa Care&quot; or &quot;us&quot; or &quot;we&quot; refers to the owner of the website. The
            term &quot;you&quot; refers to the user or viewer of our website. The use of this website is subject to the
            following terms of use:
          </p>
          <ul className="list-disc list-outside pl-6 space-y-3 text-base leading-relaxed">
            {termsList.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-light text-[#2b3d57]">Need more information?</h2>
          <p>
            If you require clarification about these terms or how they apply to you, please contact us using the details
            above. We may update this page from time to time so please review it regularly to ensure you remain happy
            with any changes.
          </p>
          <p className="text-sm tracking-[0.3em] uppercase text-[#2f4c74]">Updated: 27-02-2026</p>
        </section>
      </div>
      </section>

      <Footer />
    </div>
  </div>
);

export default TermsOfUse;



